import React from "react";
import DynamicFieldLabel from "./DynamicFieldLabel";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FormMoneyField from "shared/form/fields/moneyField";
import { useDynamicFormRenderer } from "../context/dynamicFormRendererContext";

/**
 * @name FormMoneyFieldWrapper wrapper for money type field
 * @param props
 * @constructor
 */
export default function FormMoneyFieldWrapper(props: DynamicFieldConfigType) {
  const { currencyCode, localeId } = useDynamicFormRenderer();
  return (
    <FormMoneyField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      disabled={props.schemaObj.disabled}
      required={props.schemaObj.mandatory}
      validate={props.validationFn}
      placeholder={props.schemaObj.placeholderLabel}
      conflictValue={props.schemaObj.conflictValue}
      currencyCode={currencyCode}
      localeId={localeId}
      formatValue={props.schemaObj.requiresFormatting}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
    />
  );
}
